import { useContext } from "react";
import AuthContext from "../../../store/auth-context";
import { FaPrint } from 'react-icons/fa';
import { getHeaderHtml } from "../../../util/headerUtil";
import { themeColors } from "../../../util/themeColors";
import i18n from "../../../i18n";

export const printBillReceipt = (patientData, createdBill, totalBill, amountReceived, outstandingAmount, billingDate, paymentType,
  txnNo, authCtx, billId) => {
  const hospitalData = authCtx?.hospitalData || authCtx || {};
  const { hospitalName, hospitalAddress, regnumber, doctorName } = hospitalData;
  const t = i18n.t;

  const printWindow = window.open("", "_blank", "width=900,height=650");
  if (!printWindow) return;

  printWindow.document.write(`
    <html>
      <head>
        <title>${t("Bill Receipt")}</title>
        <style>
          body { font-family: Arial, sans-serif; margin: 0px; }
          .header { text-align: center; margin-bottom: 10px; }
          .header h1 { margin: 0; font-size: 22px; font-weight: bold; text-align: center; }
          .header h3 { margin: 4px 0; font-size: 17px; font-weight: 600; text-align: center;}
          .header p { margin: 2px 0; font-size: 14px; text-align: center; }
          .patient-info { display: flex; justify-content: space-between; margin: 10px 0; font-size: 14px; }
          .patient-info .left, .patient-info .right { width: 48%; }
          .patient-info .left { text-align:left; }
          .patient-info .right { text-align:right; }
          .patient-info p { margin: 4px 0; }
          table { width: 100%; border-collapse: collapse; margin-top: 10px; }
          th, td { border: 1px solid #333; padding: 6px; text-align: left; font-size: 13px; }
          th { background: #eeeeee !important; color: #000000 !important; font-weight: bold; }
          .total { text-align: right; font-weight: bold; }
          .amount-summary { display:flex; justify-content: space-between; margin-top: 10px; font-size:14px; }
          .amount-summary .left, .amount-summary .right { width:48%; }
          .payment-summary { display:flex; justify-content: space-between; margin-top: 2px; font-size:14px; }
          .payment-summary .left, .amount-summary .right { width:48%; }
          hr { border: 0; border-top: 2px solid var(--primary-color); margin: 10px 0; opacity: 1; }
          
          /* Footer Signature positioning */
          .footer-sign {
            position: fixed;
            bottom: 30px;
            right: 30px;
            width: 220px;
            text-align: center;
          }
          @media screen {
            .footer-sign {
              position: relative;
              margin-top: 80px;
              float: right;
            }
          }
        </style>
      </head>
      <body>
        ${getHeaderHtml(hospitalData)}
        <hr/>
        <div class="patient-info">
          <div class="left">
            <p><strong>${t("Name")}:</strong> ${patientData?.firstName} ${patientData?.lastName}</p>
            <p><strong>${t("Address")}:</strong> ${patientData?.address ? patientData.address : "-"}</p>
          </div>
          <div class="right">
            <p><strong>${t("Bill No / ID")}:</strong> ${billId || "-"}</p>
            <p><strong>${t("Mobile")}:</strong> ${patientData?.mobile}</p>
            <p><strong>${t("Date")}:</strong> ${new Date(billingDate).toLocaleString('en-GB', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit', hour12: true })}</p>
          </div>
        </div>
        <table>
          <thead>
            <tr>
              <th>${t("Sr No")}</th>
              <th>${t("Expense")}</th>
               <th>${t("Amount")}</th>
               <th>${t("Quantity")}</th>
              <th>${t("Total Amt")}</th>
               <th>${t("Discount(%)")}</th>
               <th>${t("Net Amt")}</th>
            </tr>
          </thead>
          <tbody>
            ${createdBill && createdBill.length > 0
      ? createdBill
        .map(
          (bill, index) => `
                <tr>
                  <td>${index + 1}</td>
                  <td>${bill.expenseName}</td>
                  <td>${bill.actualAmount}</td>
                  <td>${bill.quantity}</td>
                  <td>${bill.actualAmount * bill.quantity}</td>
                  <td>${bill.discount}</td>
                  <td>${bill.netAmount}</td>
                </tr>`
        )
        .join("")
      : `<tr><td colspan="7" style="text-align:center;">${t("No Bill Found")}</td></tr>`
    }
            <tr>
              <td colspan="6" class="total">${t("Total")}</td>
              <td><strong>${totalBill}</strong></td>
            </tr>
          </tbody>
        </table>
        <div class="amount-summary">
          <div class="left">
            <p><strong>${t("Amount Received")}:</strong> ${amountReceived || 0}</p>
          </div>
          <div class="right">
            <p><strong>${t("Outstanding Amount")}:</strong> ${outstandingAmount || 0}</p>
          </div>
        </div>
          <div class="payment-summary">
          <div class="left">
             ${paymentType
      ? `<p><strong>${t("Payment Type")}:</strong> ${paymentType || "-"}</p>`
      : ""
    }
          </div>
          <div class="right">
            ${paymentType && paymentType.toLowerCase() !== "cash"
      ? `<p><strong>${t("Txn No")}:</strong> ${txnNo || "-"}</p>`
      : ""
    }
          </div>
        </div>

        <!-- Signature Section -->
        <div class="footer-sign">
          <div style="border-top: 1.5px solid #000; margin-bottom: 5px;"></div>
          <p style="margin: 0; font-weight: bold; font-size: 14px;">${t("Authority Sign / Doctor Sign")}</p>
          ${(() => {
      const userRole = authCtx?.role;
      const userName = authCtx?.userName;
      if (userRole === "ROLE_DOCTOR" && userName) {
        return `<p style="margin: 2px 0 0; font-size: 12px; font-weight: bold;">${userName}</p>`;
      }
      return "";
    })()}
        </div>
      </body>
    </html>
  `);

  printWindow.document.close();
  printWindow.focus();
  printWindow.print();
  printWindow.close();
};

const BillReceipt = ({ patientData, createdBill, totalBill, amountReceived, outstandingAmount, billingDate, paymentType,
  txnNo, billId }) => {
  const authCtx = useContext(AuthContext);

  return (
    <button
      onClick={() => printBillReceipt(patientData, createdBill, totalBill, amountReceived, outstandingAmount, billingDate, paymentType,
        txnNo, authCtx, billId)}
      className="btn-premium mr-3"
      disabled={!billId}
      title={!billId ? i18n.t("Please submit the bill first to generate a bill number") : ""}
      style={{ opacity: !billId ? 0.6 : 1, cursor: !billId ? 'not-allowed' : 'pointer' }}
    >
      <FaPrint className="me-2" /> {i18n.t("Print Bill")}
    </button>
  );
};


export default BillReceipt;
